import React from 'react';
import { strings } from '@purple-start-registration/common/localization';
import { REGISTRATION_TYPE } from '@purple-start-registration/common/registration';

import { SelectionDate } from './selection-date';
import { SelectionTrial } from './selection-trial';
import { SelectionMonth } from './selection-month';
import { registrationOptions } from './registration-options';

export function TrainingForm({
  config,
  data,
  onSelectionChange,
  onRegistrationTypeChange,
}) {
  function getSelector() {
    switch (data.registrationType) {
      case REGISTRATION_TYPE.PER_SESSION:
        return (
          <SelectionDate
            config={config}
            language={data.language}
            onChange={(selection) =>
              onSelectionChange(data.registrationType, selection)
            }
          />
        );
      case REGISTRATION_TYPE.PER_MONTH:
        return (
          <SelectionMonth
            config={config}
            language={data.language}
            onChange={(selection) =>
              onSelectionChange(data.registrationType, selection)
            }
          />
        );
      case REGISTRATION_TYPE.TRIAL:
        return (
          <SelectionTrial
            config={config}
            language={data.language}
            onChange={(selection) =>
              onSelectionChange(data.registrationType, selection)
            }
          />
        );
      default:
        return <p>Not implemented</p>;
    }
  }

  const options = registrationOptions(config.settings);

  return (
    <div className="md:grid md:grid-cols-3 md:gap-6">
      <div className="md:col-span-1">
        <div className="px-4 sm:px-0">
          <h3 className="text-lg font-medium leading-6 text-gray-900 rsca-title">
            {config.getTranslation(
              'sessions_sidebar_training_title',
              data.language
            ) || strings.trainingTitle}
          </h3>
          <p className="mt-1 text-sm text-gray-600">
            {config.getTranslation(
              'sessions_sidebar_training_description',
              data.language
            ) || strings.trainingDescription}
          </p>
          <div className="mt-4 space-y-4">
            {options.map(({ id, name }) => (
              <div key={id} className="flex items-center">
                <input
                  id={id}
                  value={id}
                  checked={data.registrationType === id}
                  name="reservation_type"
                  type="radio"
                  onChange={() => onRegistrationTypeChange(id)}
                  className="focus:ring-purple-500 h-4 w-4 text-purple-600 border-gray-300"
                />
                <label
                  htmlFor={id}
                  className="ml-3 block text-sm font-medium text-gray-700"
                >
                  {name}
                </label>
              </div>
            ))}
          </div>
        </div>
      </div>
      <div className="mt-5 md:mt-0 md:col-span-2">
        <div className="shadow overflow-hidden sm:rounded-md">
          <div className="px-4 py-5 bg-white space-y-6 sm:p-6">
            {getSelector()}
          </div>
        </div>
      </div>
    </div>
  );
}
